/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE9, IE10 and IE11 requires all of the following polyfills. **/
// import 'core-js/es6/symbol';
// import 'core-js/es6/object';
// import 'core-js/es6/function';
// import 'core-js/es6/parse-int';
// import 'core-js/es6/parse-float';
// import 'core-js/es6/number';
// import 'core-js/es6/math';
// import 'core-js/es6/string';
// import 'core-js/es6/date';
// import 'core-js/es6/array';
// import 'core-js/es6/regexp';
// import 'core-js/es6/map';
// import 'core-js/es6/set';


/** Evergreen browsers require these. **/
// import 'core-js/es6/reflect';
// import 'core-js/es7/reflect';
/***************************************************************************************************
 * Zone JS is no longer required - using zoneless change detection.
 */
import 'reflect-metadata';
//import 'hammerjs/hammer';


/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/**
 * Date, currency, decimal and percent pipes.
 * Needed for: All but Chrome, Firefox, Edge, IE11 and Safari 10
 */
// import 'intl';  // Run `npm install --save intl`.
// https://github.com/valor-software/ng2-dragula/issues/849#issuecomment-386579989
(window as any).global = window;

/**
 * AMD define interceptor — prevents Froala UMD plugins from registering with
 * Monaco's AMD loader when both editors load simultaneously.
 *
 * How it works:
 * - @firestitch/common source-loader sets __amdBlock > 0 and w.define = undefined
 *   before loading Froala scripts. But Monaco's loader.js can re-set window.define
 *   asynchronously, undoing the clear.
 * - This interceptor returns a proxy function WITHOUT .amd when __amdBlock > 0.
 *   Froala's UMD check (typeof define === 'function' && define.amd) fails, so it
 *   uses the global fallback. Monaco's own scripts call define() directly without
 *   checking .amd, so they pass through the proxy to the real define.
 * - The setter ignores undefined assignments (from the source-loader's clear) so
 *   Monaco's define is preserved throughout.
 */
(function () {
  const w = window as any;
  let realDefine: any = w.define;
  let proxyDefine: any = null;

  Object.defineProperty(w, 'define', {
    get() {
      if (w.__amdBlock > 0 && realDefine) {
        if (!proxyDefine) {
          proxyDefine = function () {
            return realDefine.apply(this, arguments);
          };
        }
        return proxyDefine;
      }
      return realDefine;
    },
    set(val: any) {
      if (val !== undefined) {
        realDefine = val;
        proxyDefine = null;
      }
    },
    configurable: true,
    enumerable: true,
  });
})();
